import BigNumber from 'bignumber.js';
import { minBy } from 'lodash';
import { DraftOptionLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { Maybe } from '@paradigm/utils/types';
import { areExpirationsEqual } from './expiration-utils';

export function strikeView(
  expiration: DraftOptionLeg['expiration'],
  strike: DraftOptionLeg['strike'],
  optionInstruments: UnifiedInstruments['optionInstruments'],
  perpFutureInstrument: Maybe<UnifiedInstruments['futureInstruments'][number]>,
) {
  const expiryOptions = optionInstruments.filter((instrument) =>
    areExpirationsEqual(instrument.expiration, expiration),
  );
  const strikeIndex = getSimilarStrikeIndex(
    expiryOptions,
    perpFutureInstrument,
  );

  const options = expiryOptions.map((instrument) => ({
    value: instrument.strike,
    label: instrument.strike,
    instrumentName: instrument.name,
  }));

  const selectedOption =
    options.find((option) => option.value === strike) ?? null;

  const isValid = selectedOption !== null;

  const isDisabled = options.length === 0;

  return { options, selectedOption, isValid, isDisabled, strikeIndex };
}

/**
 * Finds strike index that is closer to future PERPETUAL mark price
 */
function getSimilarStrikeIndex(
  optionInstruments: UnifiedInstruments['optionInstruments'],
  perpFutureInstrument: Maybe<UnifiedInstruments['futureInstruments'][number]>,
) {
  if (perpFutureInstrument == null) return -1;

  const instrumentWithMinStrikeDiff = minBy(optionInstruments, (inst) =>
    BigNumber(inst.strike)
      .minus(perpFutureInstrument.mark_price)
      .abs()
      .toNumber(),
  );

  if (instrumentWithMinStrikeDiff == null) return -1;

  // UI strike lists start with 1
  return optionInstruments.indexOf(instrumentWithMinStrikeDiff) + 1;
}
